import React, { useState } from 'react';
import { default as __ } from '../../utils';
import { colors } from '../../styles';
import Shape from '../utils/shape';
import Repeat from '../utils/repeat';
import Pinned from '../utils/pinned';

export { UserPala, UserPalaWithState, Attack, Control };

let palaContainerStyles = {
  minHeight: '140px',
  borderRadius: '6px',
  backgroundColor: 'var(--accent-alpha)',
  padding: '20px 0',
};

function UserPala({ style, nickname, brand, dummy, cb = __.noop() }) {
  if (dummy)
    return (
      <div
        style={{ ...palaContainerStyles }}
        className="col-center align-center "
      >
        <p className="-accent underline-double">Libre</p>
      </div>
    );
  return (
    <div
      style={{ ...palaContainerStyles }}
      className="col-between align-center "
      onClick={cb}
    >
      {style === 'attack' ? <Attack xl /> : <Control xl />}
      <p className="txt-s -accent txt-bold txt-uppercase">{nickname} </p>
    </div>
  );
}
function UserPalaWithState({
  style,
  brand,
  nickname,
  isActive = false,
  cb = __.noop(),
}) {
  return (
    <div
      style={{ ...palaContainerStyles, opacity: isActive ? 1 : 0.5 }}
      className="col-between align-center "
      onClick={cb}
    >
      {style === 'attack' ? <Attack xl /> : <Control xl />}
      <p className="txt-s -accent txt-bold txt-uppercase">
        {nickname} de {brand}{' '}
      </p>
    </div>
  );
}

function Attack({ cb = __.noop(), xl = false }) {
  return (
    <div
      style={{ position: 'relative', width: '110px', height: '56px' }}
      onClick={cb}
    >
      <Pinned isCenteredX tag="div" offsetY="-2px">
          <div className="grid grid--6 grid-gap-xs">
            <Repeat dummy times={35}>
              {({ i }) => (
                <Shape.Circle key={i} size={xl ? 8 : 6} fill={ [0,5,30].includes(i) ? "rgba(0,0,0,0)" : "var(--accent)"} />
              )}
            </Repeat>
          </div>
      </Pinned>
    </div>
  );
}

function Control({ cb = __.noop(), xl = false }) {
  return (
    <div
      style={{ position: 'relative', width: '130px', height: '56px' }}
      onClick={cb}
    >
         <Pinned isCenteredX tag="div" offsetY="-2px">
          <div className="grid grid--7 grid-gap-xs">
            <Repeat dummy times={48}>
              {({ i }) => (
                <Shape.Circle key={i} size={xl ? 8 : 6} fill={ [0,6,42].includes(i) ? "rgba(0,0,0,0)" : "var(--accent)"} />
              )}
            </Repeat>
          </div>
      </Pinned>
    </div>
  );
}
